import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY; // Clé à récupérer dans votre tableau de bord Supabase
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
